import axios from "axios";
// import router from '../router/index'
import localStorageKey from "../enumerations/localStorageKey";
// import { logout, noNeedLoginPage } from "../plugins/utils";
import { tip } from "./utils";

//axios的實例
export const httpClient = axios.create({
  baseURL: "/",
});

httpClient.translateFn = (string) => string;

const errorHandle = (status, msg, code = undefined) => {
  switch (status) {
    //400: 登入失敗，可能是帳號或是密碼錯誤
    case 400:
      if (code === "error.ONLY_ONE_ADMIN_LEFT") {
        return;
      }
      tip(msg, code);
      break;
    //401: backend session過期
    case 401:
      if (window.location.pathname === "/login") {
        tip(msg, code);
      }
      break;
    //403: 權限不足
    case 403:
      tip(msg, code);
      break;
    //404: 請求失敗
    case 404:
      tip(msg, code);
      break;

    //其他錯誤，直接拋出提示錯誤
    default:
      console.log("resp沒有攔截到的錯誤:" + msg);
  }
};

//request攔截器
httpClient.interceptors.request.use(
  (config) => {
    //發送request前 判斷vuex中是否存在token
    //若存在則統一在http請求的header都加上token
    if (
      (config.params && config.params.needAuth) ||
      (config.data !== undefined && config.data.needAuth)
    ) {
      let token = "";

      if (!!window.localStorage.getItem(localStorageKey.TOKEN)) {
        token = window.localStorage.getItem(localStorageKey.TOKEN);
        token = token.replace(/\"/gm, "");
      }
      token && (config.headers.Authorization = "Bearer " + token);
      return config;
    } else {
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

//response攔截器
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (response) {
      let str = "",
        obj = undefined;
      //L33 transfer user reset password required
      if (
        response?.data?.result.code &&
        response?.data?.result?.code === 6660001
      ) {
        return Promise.reject(response.data);
      }
      if (response.data.result === undefined) {
        errorHandle(
          response.status,
          response.data.message,
          response.data?.result?.code
        );
        // obj = undefined;
      } else {
        errorHandle(
          response.status,
          response.data.result.message,
          response.data?.result?.code
        );
        obj =
          response.data.result.validationErrors === undefined
            ? undefined
            : response.data.result.validationErrors;
      }
      if (obj !== undefined) {
        Object.keys(obj).forEach((key) => {
          str = str + obj[key][0].message + "\n";
        });
        return Promise.reject(str);
      } else {
        str =
          response.data.result === undefined
            ? response.data.message
            : response.data.result.message;
        if (response.data.result.code === "error.ONLY_ONE_ADMIN_LEFT") {
          return Promise.reject(response.data.result);
        }
        return Promise.reject(str);
      }
    } else {
      if (!window.navigator.onLine) {
        //FIXME:無網路連線method
        console.error("no network");
        // tip("Network issue, please reconnect and refresh the webpage.");
        // toInternetErrorPage();
      } else {
        return Promise.reject(error);
      }
    }
  }
);
const langSetting = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);
const langParam = langSetting
  ? langSetting
  : process.env.REACT_APP_DEFAULT_LANG;

export default function req(
  method,
  url,
  data = null,
  needAuth = false,
  needCompanyId = false,
  needLang = true,
  removeAuth = false
) {
  const companyData = localStorage.getItem(localStorageKey.COMPANY_DATA);
  const companyId =
    companyData && needCompanyId ? JSON.parse(companyData).id : null;
  method = method.toLowerCase();
  const processData =
    data instanceof FormData
      ? data
      : needCompanyId
      ? {
          lang: langParam?.replace(/-/gm, "_"),
          company_id: companyId,
          ...data,
        }
      : {
          lang: langParam?.replace(/-/gm, "_"),
          ...data,
        };
  if (!needLang) delete processData.lang;
  if (!removeAuth) {
    processData.needAuth = needAuth;
  }
  // if(!removeCompanyId) {
  //   processData.needCompanyId = needCompanyId
  // }
  if (method === "post") {
    return httpClient.post(url, processData);
  } else if (method === "get") {
    return httpClient.get(url, { params: processData });
  } else if (method === "delete") {
    return httpClient.delete(url, { params: processData });
  } else if (method === "put") {
    return httpClient.put(url, processData);
  } else {
    console.error("未知的method" + method);
    return false;
  }
}
